import { render, staticRenderFns } from "./FlechaSubir.vue?vue&type=template&id=87d8d5b4&scoped=true"
import script from "./FlechaSubir.vue?vue&type=script&lang=js"
export * from "./FlechaSubir.vue?vue&type=script&lang=js"
import style0 from "./FlechaSubir.vue?vue&type=style&index=0&id=87d8d5b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d8d5b4",
  null
  
)

export default component.exports